const Loading = () => <p>Loading...</p>;

export default Loading;
